var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthenticationTokenProvider } from './AuthenticationTokenProvider';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import { bindEmail, bindPhone, checkLoginStatus, checkPasswordStrength, getUserDepartments, getUserRoles, isUserExists, listUserAuthorizedResources, loginByEmail, loginByPhoneCode, loginByPhonePassword, loginBySubAccount, loginByUsername, refreshToken, registerByEmail, registerByPhoneCode, registerByUsername, removeUdv, resetPassword, resetPasswordByFirstLoginToken, resetPasswordByForceResetToken, sendEmail, setUdv, setUdvBatch, udv, unbindEmail, unbindPhone, updateEmail, updatePassword, updatePhone, updateUser, user } from '../graphqlapi';
import { GraphqlClient } from '../common/GraphqlClient';
import { PasswordSecurityLevel } from './types';
import { UdfTargetType } from '../../types/graphql.v2';
import { QrCodeAuthenticationClient } from './QrCodeAuthenticationClient';
import { MfaAuthenticationClient } from './MfaAuthenticationClient';
import { HttpClient, NaiveHttpClient } from '../common/HttpClient';
import { convertObjectToKeyValueList, convertUdv, convertUdvToKeyValuePair, encrypt, formatAuthorizedResources, generateRandomString, serialize, uploadFile } from '../utils';
import jwtDecode from 'jwt-decode';
import { SocialAuthenticationClient } from './SocialAuthenticationClient';
import { PublicKeyManager } from '../common/PublicKeyManager';
import { EnterpriseAuthenticationClient } from './EnterpriseAuthenticationClient';
import { BaseAuthenticationClient } from './BaseAuthenticationClient';
import { PrincipalAuthenticationClient } from './PrincipalAuthentication';
var DEFAULT_OPTIONS = {
    appId: undefined,
    tenantId: undefined,
    appHost: undefined,
    protocol: 'oidc',
    tokenEndPointAuthMethod: 'client_secret_post',
    introspectionEndPointAuthMethod: 'client_secret_post',
    revocationEndPointAuthMethod: 'client_secret_post',
    timeout: 10000,
    onError: function (code, message, data) {
        throw { code: code, message: message, data: data };
    },
    requestFrom: 'sdk',
    encryptFunction: encrypt,
    host: 'https://core.authing.cn',
    headers: {
        'userpool-id': 'x-authing-userpool-id',
        'app-id': 'x-authing-app-id',
        'request-from': 'x-authing-request-from',
        'sdk-version': 'x-authing-sdk-version',
        'tenant-id': 'x-authing-app-tenant-id',
        lang: 'x-authing-lang'
    },
    lang: 'zh-CN'
};
/**
 * @class AuthenticationClient 认证核心模块
 * @description 此模块包含注册登录、重置手机号邮箱、修改账号信息等方法，是以你的终端用户（End User）的身份进行请求，适合在需要验证用户身份的情况下使用。
 *
 * @example
 *
 * 使用方法：
 *
 * \`\`\`javascript
 * import { AuthenticationClient } from "authing-js-sdk"
 * const authenticationClient = new AuthenticationClient({
 *    appId: "YOUR_APP_ID",
 * })
 * authenticationClient.registerByEmail // 使用邮箱注册
 * authenticationClient.loginByEmail // 使用邮箱登录
 * \`\`\`
 *
 *
 * @name AuthenticationClient
 */
var AuthenticationClient = /** @class */ (function () {
    function AuthenticationClient(options) {
        Object.keys(options).forEach(function (i) { return !options[i] && delete options[i]; });
        this.options = Object.assign({}, DEFAULT_OPTIONS, options);
        this.baseClient = new BaseAuthenticationClient(this.options);
        var graphqlEndpoint = "".concat(this.baseClient.appHost, "/graphql/v2");
        // 子模块初始化顺序: GraphqlClient -> ManagementTokenProvider -> Others
        this.graphqlClient = new (this.options.graphqlClient || GraphqlClient)(graphqlEndpoint, this.options);
        this.tokenProvider = new (this.options.tokenProvider ||
            AuthenticationTokenProvider)(this.options);
        this.httpClient = new (this.options.httpClient || HttpClient)(this.options, this.tokenProvider);
        this.naiveHttpClient = new NaiveHttpClient(this.options, this.tokenProvider);
        this.publicKeyManager = new PublicKeyManager(this.options, this.httpClient);
        this.wxqrcode = new QrCodeAuthenticationClient(this.options, this.tokenProvider, this.httpClient, 'WXAPP_AUTH');
        this.qrcode = new QrCodeAuthenticationClient(this.options, this.tokenProvider, this.httpClient, 'APP_AUTH');
        this.wechatmpqrcode = new QrCodeAuthenticationClient(this.options, this.tokenProvider, this.httpClient, 'WECHATMP_AUTH');
        this.mfa = new MfaAuthenticationClient(this.options, this.tokenProvider, this.httpClient);
        this.social = new SocialAuthenticationClient(this.options, this.tokenProvider, this.httpClient);
        this.enterprise = new EnterpriseAuthenticationClient(this.options, this.tokenProvider, this.httpClient);
        this.principal = new PrincipalAuthenticationClient(this.options, this.tokenProvider, this.httpClient);
        if (this.options.token) {
            this.setToken(this.options.token);
        }
    }
    AuthenticationClient.prototype.checkLoggedIn = function () {
        var _a;
        var user = this.tokenProvider.getUser();
        if (user) {
            return user.id;
        }
        var token = this.tokenProvider.getToken();
        if (!token) {
            throw new Error('请先登录！');
        }
        var decoded = jwtDecode(token);
        var userId = decoded.sub || ((_a = decoded.data) === null || _a === void 0 ? void 0 : _a.id);
        if (!userId) {
            throw new Error('不合法的 accessToken');
        }
        return userId;
    };
    AuthenticationClient.prototype.setCurrentUser = function (user) {
        this.tokenProvider.setUser(user);
    };
    AuthenticationClient.prototype.setToken = function (token) {
        this.tokenProvider.setToken(token);
    };
    /**
     * @name registerByEmail
     * @name_zh 使用邮箱注册
     * @description 使用邮箱注册，此接口不要求用户对邮箱进行验证，用户注册之后 emailVerified 字段会为 false 。如果你希望邮箱未验证的用户不能进行登录，可以使用 pipeline 对此类请求进行拦截。
     *
     * @param {string} email 邮箱
     * @param {string} password 密码
     * @param {RegisterProfile} [profile] 用户资料
     * @param {Object} [options]
     * @param {boolean} [options.forceLogin] 是否走一遍完整的登录的，会触发登录前后的 pipeline 函数以及登录事件 webhook ，同时该用户的累计登录次数会加 1 。默认为 false 。
     * @param {boolean} [options.generateToken] 是否为该用户生成 token，不会触发登录后的完整流程，用户的累计登录次数不会加 1。默认为 false 。
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.registerByEmail(
     *  'test@example.com',
     *  'passw0rd',
     *  {
     *    nickname: 'Nick'
     *  },
     *  {
     *    generateToken: true
     *  }
     * )
     *
     * @example
     * authenticationClient.registerByEmail('test@example.com', 'passw0rd')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.registerByEmail = function (email, password, profile, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, forceLogin, _b, generateToken, clientIp, params, context, customData, phoneToken, _c, _d, _e, extraParams, extraContext, user;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        options = options || {};
                        profile = profile || {};
                        _a = options.forceLogin, forceLogin = _a === void 0 ? false : _a, _b = options.generateToken, generateToken = _b === void 0 ? false : _b, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData, phoneToken = options.phoneToken;
                        _d = (_c = this.options).encryptFunction;
                        _e = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent(), this.options.encryption]))];
                    case 2:
                        password = _f.sent();
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, registerByEmail(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    email: email,
                                    password: password,
                                    profile: profile,
                                    forceLogin: forceLogin,
                                    generateToken: generateToken,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext,
                                    phoneToken: phoneToken
                                }
                            })];
                    case 3:
                        user = (_f.sent()).registerByEmail;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name registerByUsername
     * @name_zh 使用用户名注册
     * @description 使用用户名注册
     *
     * @param {string} username 用户名
     * @param {string} password 密码
     * @param {RegisterProfile} [profile] 用户资料
     * @param {Object} [options]
     * @param {boolean} [options.forceLogin] 是否走一遍完整的登录的，会触发登录前后的 pipeline 函数以及登录事件 webhook ，同时该用户的累计登录次数会加 1 。默认为 false 。
     * @param {boolean} [options.generateToken] 是否为该用户生成 token，不会触发登录后的完整流程，用户的累计登录次数不会加 1。默认为 false 。
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     *
     * @example
     *
     * authenticationClient.registerByUsername(
     *  'bob',
     *  'passw0rd',
     *  {
     *    nickname: 'Nick'
     *  },
     *  {
     *    generateToken: true
     *  }
     * )
     *
     * @example
     * authenticationClient.registerByUsername('bob', 'passw0rd')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.registerByUsername = function (username, password, profile, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, forceLogin, _b, generateToken, clientIp, params, context, customData, phoneToken, emailToken, _c, _d, _e, extraParams, extraContext, user;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        options = options || {};
                        profile = profile || {};
                        _a = options.forceLogin, forceLogin = _a === void 0 ? false : _a, _b = options.generateToken, generateToken = _b === void 0 ? false : _b, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData, phoneToken = options.phoneToken, emailToken = options.emailToken;
                        _d = (_c = this.options).encryptFunction;
                        _e = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent(), this.options.encryption]))];
                    case 2:
                        password = _f.sent();
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, registerByUsername(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    username: username,
                                    password: password,
                                    profile: profile,
                                    forceLogin: forceLogin,
                                    generateToken: generateToken,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext,
                                    phoneToken: phoneToken,
                                    emailToken: emailToken
                                }
                            })];
                    case 3:
                        user = (_f.sent()).registerByUsername;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name registerByPhoneCode
     * @name_zh 使用手机号注册
     * @description 使用手机号注册，你可以同时设置该账号的初始密码。发送短信的接口请见 sendSmsCode
     *
     * @param {string} phone 手机号
     * @param {string} code 短信验证码
     * @param {string} password 初始密码
     * @param {RegisterProfile} [profile] 用户资料
     * @param {Object} [options]
     * @param {boolean} [options.forceLogin] 是否走一遍完整的登录的，会触发登录前后的 pipeline 函数以及登录事件 webhook ，同时该用户的累计登录次数会加 1 。默认为 false 。
     * @param {boolean} [options.generateToken] 是否为该用户生成 token，不会触发登录后的完整流程，用户的累计登录次数不会加 1。默认为 false 。
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.registerByPhoneCode(
     *  '176xxxx7041',
     *  '1234',
     *  'passw0rd',
     *  {
     *    nickname: 'Nick'
     *  },
     *  {
     *    generateToken: true
     *  }
     * )
     *
     * @example
     * authenticationClient.registerByPhoneCode('176xxxx7041', '1234')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.registerByPhoneCode = function (phone, code, password, profile, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, forceLogin, _b, generateToken, clientIp, params, context, customData, phoneCountryCode, emailToken, _c, _d, _e, extraParams, extraContext, user;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        options = options || {};
                        profile = profile || {};
                        _a = options.forceLogin, forceLogin = _a === void 0 ? false : _a, _b = options.generateToken, generateToken = _b === void 0 ? false : _b, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData, phoneCountryCode = options.phoneCountryCode, emailToken = options.emailToken;
                        if (!password) return [3 /*break*/, 3];
                        _d = (_c = this.options).encryptFunction;
                        _e = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent(), this.options.encryption]))];
                    case 2:
                        password = _f.sent();
                        _f.label = 3;
                    case 3:
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, registerByPhoneCode(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    phone: phone,
                                    code: code,
                                    phoneCountryCode: phoneCountryCode,
                                    password: password,
                                    profile: profile,
                                    forceLogin: forceLogin,
                                    generateToken: generateToken,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext,
                                    emailToken: emailToken
                                }
                            })];
                    case 4:
                        user = (_f.sent()).registerByPhoneCode;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name checkPasswordStrength
     * @name_zh 检查密码强度
     * @description 检查密码强度，详情请见: https://docs.authing.co/v2/guides/security/config-password.html
     *
     * @param {string} password
     * @example
     * authenticationClient.checkPasswordStrength('weak')
     *
     * @example
     * authenticationClient.checkPasswordStrength('strongPassw0rd!')
     *
     * @returns {Promise<CheckPasswordStrengthResult>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.checkPasswordStrength = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkPasswordStrength(this.graphqlClient, this.tokenProvider, { password: password })];
                    case 1:
                        result = (_a.sent()).checkPasswordStrength;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * @name sendSmsCode
     * @name_zh 发送短信验证码
     * @description 发送短信验证码, 短信验证码的有效时间为 60 s。
     *
     * @param {string} phone
     * @example
     * authenticationClient.sendSmsCode('176xxxx6754')
     *
     * @returns {Promise<CommonMessage>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.sendSmsCode = function (phone, phoneCountryCode, scene) {
        return __awaiter(this, void 0, void 0, function () {
            var api, params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseClient.appHost, "/api/v2/sms/send");
                        params = { phone: phone };
                        if (phoneCountryCode) {
                            params.phoneCountryCode = phoneCountryCode;
                        }
                        if (scene) {
                            params.scene = scene;
                        }
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: api,
                                data: params
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name loginByEmail
     * @name_zh 使用邮箱登录
     * @description 使用邮箱登录，该接口默认不会限制未验证的邮箱进行登录，如果你希望邮箱未验证的用户不能进行登录，可以使用 pipeline 对此类请求进行拦截。
     *
     * 如果你的用户池配置了登录失败检测，当同一  IP 下登录多次失败的时候会要求用户输入图形验证码（code 为 2000)。
     *
     * @param {string} email 邮箱
     * @param {string} password 密码
     * @param {Object} [options]
     * @param {boolean} [options.autoRegister] 是否自动注册。如果检测到用户不存在，会根据登录账密自动创建一个账号。
     * @param {string} [options.captchaCode] 图形验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.loginByEmail(
     *  'test@example.com',
     *  'passw0rd',
     *  {
     *    autoRegister: true，
     *    captchaCode: 'xj72'
     *  }
     * )
     *
     * @example
     * authenticationClient.loginByEmail('test@example.com', 'passw0rd')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByEmail = function (email, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, autoRegister, captchaCode, clientIp, params, context, customData, _b, _c, _d, extraParams, extraContext, user;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        options = options || {};
                        _a = options.autoRegister, autoRegister = _a === void 0 ? false : _a, captchaCode = options.captchaCode, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData;
                        _c = (_b = this.options).encryptFunction;
                        _d = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent(), this.options.encryption]))];
                    case 2:
                        password = _e.sent();
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, loginByEmail(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    email: email,
                                    password: password,
                                    autoRegister: autoRegister,
                                    captchaCode: captchaCode,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext
                                }
                            })];
                    case 3:
                        user = (_e.sent()).loginByEmail;
                        if (user.customData) {
                            // @ts-ignore
                            user.customData = convertUdvToKeyValuePair(user.customData);
                        }
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name loginByUsername
     * @name_zh 使用用户名登录
     * @description 使用用户名登录。
     *
     * 如果你的用户池配置了登录失败检测，当同一  IP 下登录多次失败的时候会要求用户输入图形验证码（code 为 2000)。
     *
     * @param {string} username 用户名
     * @param {string} password 密码
     * @param {Object} [options]
     * @param {boolean} [options.autoRegister] 是否自动注册。如果检测到用户不存在，会根据登录账密自动创建一个账号。
     * @param {string} [options.captchaCode] 图形验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     *
     * @example
     *
     * authenticationClient.loginByEmail(
     *  'test@example.com',
     *  'passw0rd',
     *  {
     *    autoRegister: true，
     *    captchaCode: 'xj72'
     *  }
     * )
     *
     * @example
     * authenticationClient.loginByEmail('test@example.com', 'passw0rd')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByUsername = function (username, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, autoRegister, captchaCode, clientIp, params, context, customData, _b, _c, _d, extraParams, extraContext, user;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        options = options || {};
                        _a = options.autoRegister, autoRegister = _a === void 0 ? false : _a, captchaCode = options.captchaCode, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData;
                        _c = (_b = this.options).encryptFunction;
                        _d = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent(), this.options.encryption]))];
                    case 2:
                        password = _e.sent();
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, loginByUsername(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    username: username,
                                    password: password,
                                    autoRegister: autoRegister,
                                    captchaCode: captchaCode,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext
                                }
                            })];
                    case 3:
                        user = (_e.sent()).loginByUsername;
                        if (user.customData) {
                            // @ts-ignore
                            user.customData = convertUdvToKeyValuePair(user.customData);
                        }
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name loginByPhoneCode
     * @name_zh 使用手机号验证码登录
     * @description 使用手机号验证码登录。
     *
     *
     * @param {string} phone 手机号
     * @param {string} code 短信验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.loginByPhoneCode(
     *  '176xxxx7041',
     *  '1234',
     * )
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByPhoneCode = function (phone, code, options) {
        return __awaiter(this, void 0, void 0, function () {
            var clientIp, params, context, customData, phoneCountryCode, extraParams, extraContext, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = options || {};
                        clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData, phoneCountryCode = options.phoneCountryCode;
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, loginByPhoneCode(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    phone: phone,
                                    code: code,
                                    phoneCountryCode: phoneCountryCode,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext
                                }
                            })];
                    case 1:
                        user = (_a.sent()).loginByPhoneCode;
                        if (user.customData) {
                            // @ts-ignore
                            user.customData = convertUdvToKeyValuePair(user.customData);
                        }
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name loginByEmailCode
     * @name_zh 使用邮箱号验证码登录
     * @description 使用邮箱号验证码登录。
     *
     *
     * @param {string} email 邮箱
     * @param {string} code 邮箱验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.loginByPhoneCode(
     *  'sunxxxxx@authing.cn',
     *  '1234',
     * )
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByEmailCode = function (email, code, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var clientIp, params, context, customData, phoneCountryCode, extraParams, extraContext, url, user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = options || {};
                        clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData, phoneCountryCode = options.phoneCountryCode;
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        url = "".concat((_a = this.options.appHost) !== null && _a !== void 0 ? _a : "", "/api/v2/login/email-code");
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: url,
                                data: {
                                    email: email,
                                    code: code,
                                    phoneCountryCode: phoneCountryCode,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext
                                },
                                unSetToken: true
                            })];
                    case 1:
                        user = _b.sent();
                        if (user.customData) {
                            // @ts-ignore
                            user.customData = convertUdvToKeyValuePair(user.customData);
                        }
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name loginByPhonePassword
     * @name_zh 使用手机号密码登录
     * @description 使用手机号密码登录。
     *
     *
     * @param {string} phone 手机号
     * @param {string} password 密码
     * @param {Object} [options]
     * @param {string} [options.captchaCode] 图形验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     * @example
     *
     * authenticationClient.loginByPhonePassword(
     *  '176xxxx7041',
     *  'passw0rd',
     *  {
     *    captchaCode: 'xj72'
     *  }
     * )
     *
     * @example
     * authenticationClient.loginByPhonePassword('176xxxx7041', 'passw0rd')
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByPhonePassword = function (phone, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var captchaCode, _a, autoRegister, clientIp, params, context, customData, _b, _c, _d, extraParams, extraContext, user;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        options = options || {};
                        captchaCode = options.captchaCode, _a = options.autoRegister, autoRegister = _a === void 0 ? false : _a, clientIp = options.clientIp, params = options.params, context = options.context, customData = options.customData;
                        _c = (_b = this.options).encryptFunction;
                        _d = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent(), this.options.encryption]))];
                    case 2:
                        password = _e.sent();
                        extraParams = null;
                        if (customData) {
                            extraParams = JSON.stringify(convertObjectToKeyValueList(customData));
                        }
                        else if (params) {
                            extraParams = JSON.stringify(params);
                        }
                        extraContext = null;
                        if (context) {
                            extraContext = JSON.stringify(context);
                        }
                        return [4 /*yield*/, loginByPhonePassword(this.graphqlClient, this.tokenProvider, {
                                input: {
                                    phone: phone,
                                    password: password,
                                    captchaCode: captchaCode,
                                    autoRegister: autoRegister,
                                    clientIp: clientIp,
                                    params: extraParams,
                                    context: extraContext
                                }
                            })];
                    case 3:
                        user = (_e.sent()).loginByPhonePassword;
                        if (user.customData) {
                            // @ts-ignore
                            user.customData = convertUdvToKeyValuePair(user.customData);
                        }
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    AuthenticationClient.prototype.loginBySubAccount = function (account, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var captchaCode, clientIp, _a, _b, _c, user;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        options = options || {};
                        captchaCode = options.captchaCode, clientIp = options.clientIp;
                        _b = (_a = this.options).encryptFunction;
                        _c = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent(), this.options.encryption]))];
                    case 2:
                        password = _d.sent();
                        return [4 /*yield*/, loginBySubAccount(this.graphqlClient, this.tokenProvider, {
                                account: account,
                                password: password,
                                captchaCode: captchaCode,
                                clientIp: clientIp
                            })];
                    case 3:
                        user = (_d.sent()).loginBySubAccount;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name checkLoginStatus
     * @name_zh 检测 Token 登录状态
     * @description 检测 Token 登录状态
     *
     * @param {string} token 用户的登录凭证 token
     *
     * @example
     *
     * authenticationClient.checkLoginStatus('TOKEN')
     *
     * @returns {Promise<JwtTokenStatus>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.checkLoginStatus = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkLoginStatus(this.graphqlClient, this.tokenProvider, {
                            token: token
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.checkLoginStatus];
                }
            });
        });
    };
    /**
     * @name sendEmail
     * @name_zh 发送邮件
     * @description 发送邮件
     *
     * @param {string} email 邮箱
     * @param {EmailScene} scene 发送场景，可选值为 RESET_PASSWORD（发送重置密码邮件，邮件中包含验证码）、VerifyEmail（发送验证邮箱的邮件）、ChangeEmail（发送修改邮箱邮件，邮件中包含验证码）
     *
     * @example
     *
     * import { EmailScene } from "authing-js-sdk"
     * authenticationClient.sendEmail('test@example.com', EmailScene.RESET_PASSWORD)
     *
     * @returns {Promise<CommonMessage>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.sendEmail = function (email, scene) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sendEmail(this.graphqlClient, this.tokenProvider, { email: email, scene: scene })];
                    case 1:
                        data = (_a.sent()).sendEmail;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name resetPasswordByPhoneCode
     * @name_zh 通过短信验证码重置密码
     * @description 通过短信验证码重置密码，你需要先调用 sendSmsCode 接口发送重置密码邮件。
     *
     * @param {string} phone 手机号
     * @param {string} code 验证码
     * @param {string} newPassword 新的密码
     *
     * @example
     *
     * authenticationClient.resetPasswordByPhoneCode('176xxxx7041', '1234', 'passw0rd')
     *
     * @returns {Promise<CommonMessage>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.resetPasswordByPhoneCode = function (phone, code, newPassword, phoneCountryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = this.options).encryptFunction;
                        _c = [newPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent(), this.options.encryption]))];
                    case 2:
                        newPassword = _d.sent();
                        return [4 /*yield*/, resetPassword(this.graphqlClient, this.tokenProvider, {
                                phone: phone,
                                code: code,
                                newPassword: newPassword,
                                phoneCountryCode: phoneCountryCode
                            })];
                    case 3:
                        data = (_d.sent()).resetPassword;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name resetPasswordByEmailCode
     * @name_zh 通过邮件验证码重置密码
     * @description 通过邮件验证码重置密码，你需要先调用 sendEmail 接口发送重置密码邮件。
     *
     * @param {string} phone 手机号
     * @param {string} code 验证码
     * @param {string} newPassword 新的密码
     *
     * @example
     *
     * authenticationClient.resetPasswordByEmailCode('test@example.com', '1234', 'passw0rd')
     *
     * @returns {Promise<CommonMessage>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.resetPasswordByEmailCode = function (email, code, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = this.options).encryptFunction;
                        _c = [newPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent(), this.options.encryption]))];
                    case 2:
                        newPassword = _d.sent();
                        return [4 /*yield*/, resetPassword(this.graphqlClient, this.tokenProvider, {
                                email: email,
                                code: code,
                                newPassword: newPassword
                            })];
                    case 3:
                        data = (_d.sent()).resetPassword;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AuthenticationClient.prototype.resetPasswordByFirstLoginToken = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var token, password, _a, _b, _c, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        token = params.token, password = params.password;
                        _b = (_a = this.options).encryptFunction;
                        _c = [password];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent(), this.options.encryption]))];
                    case 2:
                        password = _d.sent();
                        return [4 /*yield*/, resetPasswordByFirstLoginToken(this.graphqlClient, this.tokenProvider, {
                                token: token,
                                password: password
                            })];
                    case 3:
                        data = (_d.sent()).resetPasswordByFirstLoginToken;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AuthenticationClient.prototype.resetPasswordByForceResetToken = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var token, newPassword, oldPassword, _a, _b, _c, _d, _e, _f, data;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        token = params.token, newPassword = params.newPassword, oldPassword = params.oldPassword;
                        _b = (_a = this.options).encryptFunction;
                        _c = [newPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_g.sent(), this.options.encryption]))];
                    case 2:
                        newPassword = _g.sent();
                        _e = (_d = this.options).encryptFunction;
                        _f = [oldPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 3: return [4 /*yield*/, _e.apply(_d, _f.concat([_g.sent(), this.options.encryption]))];
                    case 4:
                        oldPassword = _g.sent();
                        return [4 /*yield*/, resetPasswordByForceResetToken(this.graphqlClient, this.tokenProvider, {
                                token: token,
                                oldPassword: oldPassword,
                                newPassword: newPassword
                            })];
                    case 5:
                        data = (_g.sent()).resetPasswordByForceResetToken;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name updateProfile
     * @name_zh 修改用户资料
     * @description 修改用户资料，此接口不能用于修改手机号、邮箱、密码，如果需要请调用 updatePhone、updateEmail、updatePassword 接口。
     *
     * @param {UpdateUserInput} updates 修改的用户资料
     * @param {string} updates.username 用户名
     * @param {string} updates.nickname 昵称
     * @param {string} updates.photo 头像
     * @param {string} updates.company 公司
     * @param {string} updates.browser 浏览器
     * @param {string} updates.device 设备
     * @param {string} updates.lastIP 最近登录的 IP
     * @param {string} updates.name Name
     * @param {string} updates.givenName Given Name
     * @param {string} updates.familyName Family Name
     * @param {string} updates.middleName Middle Name
     * @param {string} updates.profile Profile Url
     * @param {string} updates.preferredUsername Preferred Name
     * @param {string} updates.website 个人网站
     * @param {string} updates.gender 性别, F 表示男性、W 表示女性、未知表示 U
     * @param {string} updates.birthdate 生日
     * @param {string} updates.zoneinfo 时区
     * @param {string} updates.locale 语言
     * @param {string} updates.address 地址
     * @param {string} updates.streetAddress 街道地址
     * @param {string} updates.locality
     * @param {string} updates.region 地域
     * @param {string} updates.postalCode 邮编
     * @param {string} updates.city 城市
     * @param {string} updates.province 省份
     * @param {string} updates.country 国家
     *
     * @example
     *
     * authenticationClient.updateProfile({
     *  nickname: "Nick",
     *  lastIp: "111.111.111.111"
     * })
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.updateProfile = function (updates, options) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, _a, emailToken, phoneToken, updated;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        _a = options || {}, emailToken = _a.emailToken, phoneToken = _a.phoneToken;
                        if (updates && updates.password) {
                            delete updates.password;
                        }
                        return [4 /*yield*/, updateUser(this.graphqlClient, this.tokenProvider, {
                                id: userId,
                                input: updates,
                                emailToken: emailToken,
                                phoneToken: phoneToken
                            })];
                    case 1:
                        updated = (_b.sent()).updateUser;
                        this.setCurrentUser(updated);
                        return [2 /*return*/, updated];
                }
            });
        });
    };
    /**
     * @name updatePassword
     * @name_zh 更新用户密码
     * @description 更新用户密码
     *
     * @param {string} newPassword 新密码
     * @param {string} [oldPassword] 旧密码，如果用户没有设置密码，可以不填。
     *
     * @example
     *
     * authenticationClient.updatePassword('passw0rd') // 由手机号、社会化登录等其他方式注册的，首次没有设置密码，oldPassword 留空。
     *
     * @example
     *
     * authenticationClient.updatePassword('passw0rd', 'oldPassw0rd') // 用户之前设置了密码
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.updatePassword = function (newPassword, oldPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, user;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _a = newPassword;
                        if (!_a) return [3 /*break*/, 3];
                        _c = (_b = this.options).encryptFunction;
                        _d = [newPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 1: return [4 /*yield*/, _c.apply(_b, _d.concat([_j.sent(), this.options.encryption]))];
                    case 2:
                        _a = (_j.sent());
                        _j.label = 3;
                    case 3:
                        newPassword = _a;
                        _e = oldPassword;
                        if (!_e) return [3 /*break*/, 6];
                        _g = (_f = this.options).encryptFunction;
                        _h = [oldPassword];
                        return [4 /*yield*/, this.publicKeyManager.getPublicKey()];
                    case 4: return [4 /*yield*/, _g.apply(_f, _h.concat([_j.sent(), this.options.encryption]))];
                    case 5:
                        _e = (_j.sent());
                        _j.label = 6;
                    case 6:
                        oldPassword = _e;
                        return [4 /*yield*/, updatePassword(this.graphqlClient, this.tokenProvider, {
                                newPassword: newPassword,
                                oldPassword: oldPassword
                            })];
                    case 7:
                        user = (_j.sent()).updatePassword;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name updatePhone
     * @name_zh 更新用户手机号
     * @description 更新用户手机号。和修改邮箱一样，默认情况下，如果用户当前已经绑定了手机号，需要同时验证原有手机号（目前账号绑定的手机号）和当前邮箱（将要绑定的手机号）。
     * 也就是说，用户 A 当前绑定的手机号为 15888888888，想修改为 15899999999，那么就需要同时验证这两个手机号。
     * 开发者也可以选择不开启 “验证原有手机号“ ，可以在 Authing 控制台 的 设置目录下的安全信息模块进行关闭。
     * 用户首次绑定手机号请使用 bindPhone 接口。
     *
     * @param {string} phone 新手机号
     * @param {string} phoneCode 新手机号的验证码
     * @param {string} [oldPhone] 旧手机号
     * @param {string} [oldPhoneCode] 旧手机号的验证码
     *
     * @example
     *
     * authenticationClient.updatePhone('176xxxx7041', '1234') // 关闭了“验证原有手机号“选项
     *
     * @example
     *
     * authenticationClient.updatePhone('176xxxx7041', '1234', '156xxxx9876', '1234') // 开启了“验证原有手机号“选项
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.updatePhone = function (phone, phoneCode, oldPhone, oldPhoneCode, phoneCountryCode, oldPhoneCountryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, updatePhone(this.graphqlClient, this.tokenProvider, {
                            phone: phone,
                            phoneCode: phoneCode,
                            oldPhone: oldPhone,
                            oldPhoneCode: oldPhoneCode,
                            phoneCountryCode: phoneCountryCode,
                            oldPhoneCountryCode: oldPhoneCountryCode
                        })];
                    case 1:
                        user = (_a.sent()).updatePhone;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name updateEmail
     * @name_zh 更新用户邮箱
     * @description 如果用户已经绑定了邮箱，默认情况下，需要同时验证原有邮箱（目前账号绑定的邮箱）和当前邮箱（将要绑定的邮箱）。也就是说，用户 A 当前绑定的邮箱为 123456@qq.com，想修改为 1234567@qq.com，那么就需要同时验证这两个邮箱。
     * 开发者也可以选择不开启 “验证原有邮箱“ ，可以在 Authing 控制台 的 设置目录下的安全信息模块进行关闭。
     * 用户首次绑定手机号请使用 bindEmail 接口。
     *
     * @param {string} email 新邮箱
     * @param {string} emailCode 新邮箱的验证码
     * @param {string} [oldEmail] 旧邮箱
     * @param {string} [oldEmailCode] 旧邮箱的验证码
     *
     * @example
     *
     * authenticationClient.updateEmail('test@example.com', '1234') // 关闭了“验证原有邮箱“选项
     *
     * @example
     *
     * authenticationClient.updateEmail('test@example.com', '1234', 'test2@example.com', '1234') // 开启了“验证原有邮箱“选项
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.updateEmail = function (email, emailCode, oldEmail, oldEmailCode) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, updateEmail(this.graphqlClient, this.tokenProvider, {
                            email: email,
                            emailCode: emailCode,
                            oldEmail: oldEmail,
                            oldEmailCode: oldEmailCode
                        })];
                    case 1:
                        user = (_a.sent()).updateEmail;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name refreshToken
     * @name_zh 刷新当前用户的 token
     * @description 刷新当前用户的 token，调用此接口要求先登录。
     *
     * @example
     *
     * authenticationClient.updateEmail()
     *
     * @returns {Promise<RefreshToken>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, refreshToken(this.graphqlClient, this.tokenProvider, {})];
                    case 1:
                        data = (_a.sent()).refreshToken;
                        this.setToken(data.token);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name linkAccount
     * @name_zh 关联账号
     * @description 将社交账号绑定到主账号（手机号、邮箱账号）。
     *
     * @param {Object} options
     * @param {string} options.primaryUserToken 主账号 Token
     * @param {string} options.secondaryUserToken 社交账号 Token
     *
     * @example
     *
     * authenticationClient.linkAccount({ primaryUserToken: '', secondaryUserToken: '' })
     *
     * @returns {{code: 200, message: "绑定成功"}}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.linkAccount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: 'POST',
                            url: "".concat(this.baseClient.appHost, "/api/v2/users/link"),
                            data: {
                                primaryUserToken: options.primaryUserToken,
                                secondaryUserToken: options.secondaryUserToken
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { code: 200, message: '绑定成功' }];
                }
            });
        });
    };
    /**
     * @name unLinkAccount
     * @name_zh 解除账号绑定
     * @description 将社交账号从主账号（手机号、邮箱账号）解绑。
     *
     * @param {Object} options
     * @param {string} options.primaryUserToken 主账号 Token
     * @param {string} options.provider 社交账号的提供商名称
     *
     * @example
     *
     * authenticationClient.unLinkAccount({ primaryUserToken: '', provider: 'wechat:pc' })
     *
     * @returns {{code: 200, message: "解绑成功"}}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.unLinkAccount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: 'POST',
                            url: "".concat(this.baseClient.appHost, "/api/v2/users/unlink"),
                            data: {
                                primaryUserToken: options.primaryUserToken,
                                provider: options.provider
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { code: 200, message: '解绑成功' }];
                }
            });
        });
    };
    /**
     * @name bindPhone
     * @name_zh 绑定手机号
     * @description 用户初次绑定手机号，如果需要修改手机号请使用 updatePhone 接口。
     *
     * @param {string} phone
     * @param {string} phoneCode
     *
     * @example
     *
     * authenticationClient.bindPhone('176xxxx7041', '1234')
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.bindPhone = function (phone, phoneCode, phoneCountryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, bindPhone(this.graphqlClient, this.tokenProvider, {
                            phone: phone,
                            phoneCode: phoneCode,
                            phoneCountryCode: phoneCountryCode
                        })];
                    case 1:
                        user = (_a.sent()).bindPhone;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name unbindPhone
     * @name_zh 解绑手机号
     * @description 用户解绑手机号
     *
     * @example
     *
     * authenticationClient.unbindPhone()
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.unbindPhone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, unbindPhone(this.graphqlClient, this.tokenProvider, {})];
                    case 1:
                        user = (_a.sent()).unbindPhone;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name bindEmail
     * @name_zh 绑定邮箱号
     * @description 用户邮箱号
     *
     * @param {string} email
     * @param {string} emailCode
     *
     * @example
     *
     * authenticationClient.bindEmail('test@example.com', '1234')
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.bindEmail = function (email, emailCode) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, bindEmail(this.graphqlClient, this.tokenProvider, {
                            email: email,
                            emailCode: emailCode
                        })];
                    case 1:
                        user = (_a.sent()).bindEmail;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name unbindEmail
     * @name_zh 解绑邮箱号
     * @description 用户解绑邮箱号
     *
     * @example
     *
     * authenticationClient.unbindPhone()
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.unbindEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, unbindEmail(this.graphqlClient, this.tokenProvider, {})];
                    case 1:
                        user = (_a.sent()).unbindEmail;
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name getCurrentUser
     * @name_zh 获取当前登录的用户信息
     * @description 获取当前登录的用户信息
     *
     * @example
     *
     * authenticationClient.getCurrentUser()
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, user(this.graphqlClient, this.tokenProvider, {})];
                    case 1:
                        data = (_b.sent()).user;
                        if (data.customData) {
                            // @ts-ignore
                            data.customData = convertUdvToKeyValuePair(data.customData);
                        }
                        this.setCurrentUser(data);
                        return [2 /*return*/, data];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @name logout
     * @name_zh 退出登录
     * @description 退出登录，清空 localStorage 里的 user 和 token
     *
     * @example
     *
     * authenticationClient.logout()
     *
     * @returns {null}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: 'GET',
                            url: "".concat(this.baseClient.appHost, "/api/v2/logout?app_id=").concat(this.options.appId),
                            withCredentials: true
                        })];
                    case 1:
                        _a.sent();
                        this.tokenProvider.clearUser();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @name listUdv
     * @name_zh 获取当前用户的自定义数据列表
     * @description 获取当前用户的自定义数据列表
     * @deprecated use getUdfValue instead
     *
     * @example
     *
     * authenticationClient.listUdv()
     *
     * @returns {Promise<Array<UserDefinedData>>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.listUdv = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userId, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, udv(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId
                            })];
                    case 1:
                        list = (_a.sent()).udv;
                        return [2 /*return*/, convertUdv(list)];
                }
            });
        });
    };
    /**
     * @name setUdv
     * @name_zh 添加自定义数据
     * @description 添加自定义数据
     *
     * @param {string} key 自定义字段的 key
     * @param {any} value 自定义数据的值，值的类型必须要和用户池定义的自定义字段类型一致。
     *
     * @example
     *
     * authenticationClient.setUdv('school', '清华大学') // 要求用户必须定义了 school 这个字段。
     *
     * @returns {Promise<Array<UserDefinedData>>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.setUdv = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        value = JSON.stringify(value);
                        return [4 /*yield*/, setUdv(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId,
                                key: key,
                                value: value
                            })];
                    case 1:
                        list = (_a.sent()).setUdv;
                        return [2 /*return*/, convertUdv(list)];
                }
            });
        });
    };
    /**
     * @name removeUdv
     * @name_zh 删除自定义数据
     * @description 删除自定义数据
     *
     * @param key 自定义字段的 key
     *
     * @example
     *
     * authenticationClient.removeUdv('school')
     *
     *
     * @returns {Promise<Array<UserDefinedData>>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.removeUdv = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, removeUdv(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId,
                                key: key
                            })];
                    case 1:
                        list = (_a.sent()).removeUdv;
                        return [2 /*return*/, convertUdv(list)];
                }
            });
        });
    };
    /**
     * @name listOrg
     * @name_zh 获取用户所在组织机构
     * @description 获取用户所在的组织机构立碑，以及他所属的节点在此组织机构内的完整路径。
     *
     * @example
     *
     * const data = await authenticationClient.listOrgs();
     *
     * @returns {Promise<UserOrgList>}
     *
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.listOrgs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: 'GET',
                            url: "".concat(this.baseClient.appHost, "/api/v2/users/me/orgs")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description 获取用户
     *
     */
    AuthenticationClient.prototype.listDepartments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userId, departments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, getUserDepartments(this.graphqlClient, this.tokenProvider, {
                                id: userId
                            })];
                    case 1:
                        departments = (_a.sent()).user.departments;
                        return [2 /*return*/, departments];
                }
            });
        });
    };
    /**
     * @name loginByLdap
     * @name_zh 使用 LDAP 用户名登录
     * @description 使用 LDAP 用户名登录。
     *
     * 如果你的用户池配置了登录失败检测，当同一  IP 下登录多次失败的时候会要求用户输入图形验证码（code 为 2000)。
     *
     * @param {string} username 用户名
     * @param {string} password 密码
     * @param {Object} [options]
     * @param {boolean} [options.autoRegister] 是否自动注册。如果检测到用户不存在，会根据登录账密自动创建一个账号。
     * @param {string} [options.captchaCode] 图形验证码
     * @param {string} [options.clientIp] 客户端真实 IP，如果你在服务器端调用此接口，请务必将此参数设置为终端用户的真实 IP。
     *
     *
     * @example
     * const authenticationClient = new AuthenticationClient({
     *   appId: '应用 ID'
     * })
     *
     * authenticationClient.loginByLdap(
     *  'admin',
     *  'admin',
     * )
     *
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByLdap = function (username, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var clientIp, withCustomData, api, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = options || {};
                        clientIp = options.clientIp, withCustomData = options.withCustomData;
                        api = "".concat(this.baseClient.appHost, "/api/v2/ldap/verify-user");
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: api,
                                data: {
                                    username: username,
                                    password: password,
                                    clientIp: clientIp,
                                    withCustomData: withCustomData
                                }
                            })];
                    case 1:
                        user = _a.sent();
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @name loginByAd
     * @name_zh 使用 AD 用户名登录
     * @description 使用 AD 用户名登录。
     *
     * @param {string} username 用户名
     * @param {string} password 密码
     *
     *
     * @example
     * const authenticationClient = new AuthenticationClient({
     *   appId: '应用 ID'
     * })
     *
     * authenticationClient.loginByAd(
     *  'admin',
     *  'admin',
     * )
     *
     * @returns {Promise<User>}
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.loginByAd = function (username, password, options) {
        return __awaiter(this, void 0, void 0, function () {
            var clientIp, withCustomData, firstLevelDomain, websocketHost, api, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = options || {};
                        clientIp = options.clientIp, withCustomData = options.withCustomData;
                        firstLevelDomain = new URL(this.baseClient.appHost).hostname
                            .split('.')
                            .slice(1)
                            .join('.');
                        websocketHost = this.options.websocketHost || "https://ws.".concat(firstLevelDomain);
                        api = "".concat(websocketHost, "/api/v2/ad/verify-user");
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: api,
                                data: {
                                    username: username,
                                    password: password,
                                    clientIp: clientIp,
                                    withCustomData: withCustomData
                                }
                            })];
                    case 1:
                        user = _a.sent();
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @description 上传图片
     */
    AuthenticationClient.prototype.uploadPhoto = function (accept, cb) {
        accept = accept || 'image/*';
        var authing = this;
        uploadFile({
            accept: accept,
            url: "".concat(this.baseClient.appHost, "/api/v2/upload?folder=avatar")
        })
            .then(function (_a) {
            var url = _a.url;
            return cb(url);
        })
            .catch(function (_a) {
            var code = _a.code, message = _a.message;
            return authing.options.onError(code, message);
        });
    };
    /**
     * @deprecated use uploadAvatar instead
     * @description 更新用户头像
     */
    AuthenticationClient.prototype.updateAvatar = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadAvatar(options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description 一键上传图片并更新用户头像
     *
     * @param {Object} options
     * @param {string} options.accept 支持的图片格式，默认为 'image/*'
     *
     * @example
     * const authenticationClient = new AuthenticationClient({
     *   appId: 'APP_ID',
     *   appHost: 'https://xxx.authing.cn'
     * })
     *
     * // 会自动打开浏览器文件上传框，并自动完成图片文件上传 CDN、修改用户头像操作。
     * authenticationClient.uploadAvatar()
     *
     * // 只支持 png 格式图片
     * authenticationClient.uploadAvatar({
     *   accept: '.png'
     * })
     *
     * @returns
     */
    AuthenticationClient.prototype.uploadAvatar = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var accept, task, src, user;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accept = (options || {}).accept;
                        this.checkLoggedIn();
                        task = new Promise(function (resolve) {
                            _this.uploadPhoto(accept, function (src) {
                                resolve(src);
                            });
                        });
                        return [4 /*yield*/, task];
                    case 1:
                        src = _a.sent();
                        return [4 /*yield*/, this.updateProfile({ photo: src })];
                    case 2:
                        user = _a.sent();
                        this.setCurrentUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * @description 获取当前用户的所有自定义数据
     *
     */
    AuthenticationClient.prototype.getUdfValue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userId, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, udv(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId
                            })];
                    case 1:
                        list = (_a.sent()).udv;
                        return [2 /*return*/, convertUdvToKeyValuePair(list)];
                }
            });
        });
    };
    /**
     * @description 设置自定义字段值
     *
     */
    AuthenticationClient.prototype.setUdfValue = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Object.keys(data).length === 0) {
                            throw new Error('empty udf value list');
                        }
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, setUdvBatch(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId,
                                udvList: Object.keys(data).map(function (key) { return ({
                                    key: key,
                                    value: JSON.stringify(data[key])
                                }); })
                            })];
                    case 1:
                        result = (_a.sent()).setUdvBatch;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * @description 删除用户自定义数据
     */
    AuthenticationClient.prototype.removeUdfValue = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var userId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        return [4 /*yield*/, removeUdv(this.graphqlClient, this.tokenProvider, {
                                targetType: UdfTargetType.User,
                                targetId: userId,
                                key: key
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @name getSecurityLevel
     * @name_zh 用户安全等级
     * @description 获取用户的安全等级评分
     *
     * @example
     *
     * const data = await authenticationClient.getSecurityLevel();
     *
     * @returns {Promise<SecurityLevel>}
     *
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.getSecurityLevel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: 'GET',
                            url: "".concat(this.baseClient.appHost, "/api/v2/users/me/security-level")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description 获取用户被授权的所有资源
     *
     * @param userId
     * @param namespace
     */
    AuthenticationClient.prototype.listAuthorizedResources = function (namespace, options) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, resourceType, user, _a, list, totalCount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userId = this.checkLoggedIn();
                        resourceType = (options || {}).resourceType;
                        return [4 /*yield*/, listUserAuthorizedResources(this.graphqlClient, this.tokenProvider, {
                                id: userId,
                                namespace: namespace,
                                resourceType: resourceType
                            })];
                    case 1:
                        user = (_b.sent()).user;
                        if (!user) {
                            throw new Error('用户不存在');
                        }
                        _a = user.authorizedResources, list = _a.list, totalCount = _a.totalCount;
                        list = formatAuthorizedResources(list);
                        return [2 /*return*/, {
                                list: list,
                                totalCount: totalCount
                            }];
                }
            });
        });
    };
    /**
     * @description 检查用户是否存在
     */
    AuthenticationClient.prototype.isUserExists = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var username, email, phone, externalId, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        username = options.username, email = options.email, phone = options.phone, externalId = options.externalId;
                        return [4 /*yield*/, isUserExists(this.graphqlClient, this.tokenProvider, {
                                username: username,
                                email: email,
                                phone: phone,
                                externalId: externalId
                            })];
                    case 1:
                        data = (_a.sent()).isUserExists;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @name computedPasswordSecurityLevel
     * @name_zh 计算密码安全等级
     * @description 计算密码安全等级
     *
     * @example
     *
     * const data = authenticationClient.computedPasswordSecurityLevel('xxxxxxxx');
     *
     * @returns {PasswordSecurityLevel}
     *
     * @memberof AuthenticationClient
     */
    AuthenticationClient.prototype.computedPasswordSecurityLevel = function (password) {
        if (typeof password !== 'string') {
            throw 'password must be a `string`';
        }
        var highLevel = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{12,}$/g);
        var middleLevel = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[^]{8,}$/g);
        if (password.match(highLevel) !== null) {
            return PasswordSecurityLevel.HIGH;
        }
        if (password.match(middleLevel) !== null) {
            return PasswordSecurityLevel.MIDDLE;
        }
        return PasswordSecurityLevel.LOW;
    };
    AuthenticationClient.prototype._generateTokenRequest = function (params) {
        var ret = {};
        // 删掉所有 undefined 的 kv
        Object.keys(params).map(function (key) {
            if (typeof params[key] !== 'undefined') {
                ret[key] = params[key];
            }
        });
        var p = new URLSearchParams(ret);
        return p.toString();
    };
    AuthenticationClient.prototype._generateBasicAuthToken = function (appId, secret) {
        var id = appId || this.options.appId;
        var s = secret || this.options.secret;
        var token = 'Basic ' + Buffer.from(id + ':' + s).toString('base64');
        return token;
    };
    /**
     * @param {string} code 授权码 code
     * @param {string} codeVerifier 校验码 codeVerifier
     */
    AuthenticationClient.prototype._getAccessTokenByCodeWithClientSecretPost = function (code, codeVerifier) {
        return __awaiter(this, void 0, void 0, function () {
            var qstr, api, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            client_secret: this.options.secret,
                            grant_type: 'authorization_code',
                            code: code,
                            redirect_uri: this.options.redirectUri,
                            code_verifier: codeVerifier
                        });
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    /**
     * @param {string} code 授权码 code
     * @param {string} codeVerifier 校验码 codeVerifier
     */
    AuthenticationClient.prototype._getAccessTokenByCodeWithClientSecretBasic = function (code, codeVerifier) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        qstr = this._generateTokenRequest({
                            grant_type: 'authorization_code',
                            code: code,
                            redirect_uri: this.options.redirectUri,
                            code_verifier: codeVerifier
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                data: qstr,
                                method: 'POST',
                                url: api,
                                headers: {
                                    Authorization: this._generateBasicAuthToken()
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    /**
     * @param {string} code 授权码 code
     * @param {string} codeVerifier 校验码 codeVerifier
     */
    AuthenticationClient.prototype._getAccessTokenByCodeWithNone = function (code, codeVerifier) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            grant_type: 'authorization_code',
                            code: code,
                            redirect_uri: this.options.redirectUri,
                            code_verifier: codeVerifier
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype.getAccessTokenByCode = function (code, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!['oauth', 'oidc'].includes(this.options.protocol)) {
                            throw new Error('初始化 AuthenticationClient 时传入的 protocol 参数必须为 oauth 或 oidc，请检查参数');
                        }
                        if (!this.options.secret &&
                            this.options.tokenEndPointAuthMethod !== 'none') {
                            throw new Error('请在初始化 AuthenticationClient 时传入 appId 和 secret 参数');
                        }
                        if (!(this.options.tokenEndPointAuthMethod === 'client_secret_post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._getAccessTokenByCodeWithClientSecretPost(code, options === null || options === void 0 ? void 0 : options.codeVerifier)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(this.options.tokenEndPointAuthMethod === 'client_secret_basic')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._getAccessTokenByCodeWithClientSecretBasic(code, options === null || options === void 0 ? void 0 : options.codeVerifier)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(this.options.tokenEndPointAuthMethod === 'none')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._getAccessTokenByCodeWithNone(code, options === null || options === void 0 ? void 0 : options.codeVerifier)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationClient.prototype.generateCodeChallenge = function () {
        return generateRandomString(43);
    };
    AuthenticationClient.prototype.getCodeChallengeDigest = function (options) {
        if (!options) {
            throw new Error('请提供 options 参数，options.codeChallenge 为一个长度大于等于 43 的字符串，options.method 可选值为 S256、plain');
        }
        if (!options.codeChallenge) {
            throw new Error('请提供 options.codeChallenge，值为一个长度大于等于 43 的字符串');
        }
        var _a = options.method, method = _a === void 0 ? 'S256' : _a;
        if (method === 'S256') {
            // url safe base64
            return sha256(options.codeChallenge)
                .toString(CryptoJS.enc.Base64)
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=/g, '');
        }
        if (method === 'plain') {
            return options.codeChallenge;
        }
        throw new Error('不支持的 options.method，可选值为 S256、plain');
    };
    AuthenticationClient.prototype.getAccessTokenByClientCredentials = function (scope, options) {
        return __awaiter(this, void 0, void 0, function () {
            var i, s, qstr, api, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!scope) {
                            throw new Error('请传入 scope 参数，请看文档：https://docs.authing.cn/v2/guides/authorization/m2m-authz.html');
                        }
                        if (!options) {
                            throw new Error('请在调用本方法时传入 { accessKey: string, accessSecret: string }，请看文档：https://docs.authing.cn/v2/guides/authorization/m2m-authz.html'
                            // '请在初始化 AuthenticationClient 时传入 appId 和 secret 参数或者在调用本方法时传入 { accessKey: string, accessSecret: string }，请看文档：https://docs.authing.cn/v2/guides/authorization/m2m-authz.html'
                            );
                        }
                        i = (options === null || options === void 0 ? void 0 : options.accessKey) || this.options.appId;
                        s = (options === null || options === void 0 ? void 0 : options.accessSecret) || this.options.secret;
                        qstr = this._generateTokenRequest({
                            client_id: i,
                            client_secret: s,
                            grant_type: 'client_credentials',
                            scope: scope
                        });
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype.getUserInfoByAccessToken = function (accessToken, options) {
        return __awaiter(this, void 0, void 0, function () {
            var api, userInfo, userInfo, userInfo, userInfo, userInfo, userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (options) {
                            if (options.method && !['POST', 'GET'].includes(options.method)) {
                                throw new Error('options.method 参数的可选值为 POST、GET，请检查输入');
                            }
                            if (options.tokenPlace &&
                                !['query', 'header', 'body'].includes(options.tokenPlace)) {
                                throw new Error('options.tokenPlace 参数的可选值为 query、header、body，请检查输入');
                            }
                            if (options.method === 'GET' && options.tokenPlace === 'body') {
                                throw new Error('options.method 参数为 GET 时，options.tokenPlace 参数不能为 body');
                            }
                            options.method = options.method || 'GET';
                            options.tokenPlace = options.tokenPlace || 'query';
                        }
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/me");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/me");
                        }
                        if (!((options === null || options === void 0 ? void 0 : options.method) === 'POST')) return [3 /*break*/, 7];
                        if (!((options === null || options === void 0 ? void 0 : options.tokenPlace) === 'header')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                headers: {
                                    Authorization: 'Bearer ' + accessToken
                                }
                            })];
                    case 1:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 2:
                        if (!((options === null || options === void 0 ? void 0 : options.tokenPlace) === 'query')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                params: {
                                    access_token: accessToken
                                }
                            })];
                    case 3:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 4:
                        if (!((options === null || options === void 0 ? void 0 : options.tokenPlace) === 'body')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: serialize({
                                    access_token: accessToken
                                })
                            })];
                    case 5:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 6: return [3 /*break*/, 14];
                    case 7:
                        if (!((options === null || options === void 0 ? void 0 : options.method) === 'GET')) return [3 /*break*/, 12];
                        if (!((options === null || options === void 0 ? void 0 : options.tokenPlace) === 'header')) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'GET',
                                url: api,
                                headers: {
                                    Authorization: 'Bearer ' + accessToken
                                }
                            })];
                    case 8:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 9:
                        if (!((options === null || options === void 0 ? void 0 : options.tokenPlace) === 'query')) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'GET',
                                url: api,
                                params: {
                                    access_token: accessToken
                                }
                            })];
                    case 10:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 11: return [3 /*break*/, 14];
                    case 12: return [4 /*yield*/, this.naiveHttpClient.request({
                            method: 'GET',
                            url: api,
                            params: {
                                access_token: accessToken
                            }
                        })];
                    case 13:
                        userInfo = _a.sent();
                        return [2 /*return*/, userInfo];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationClient.prototype.buildAuthorizeUrl = function (options) {
        if (!this.baseClient.appHost) {
            throw new Error('请在初始化 AuthenticationClient 时传入应用域名 appHost 参数，形如：https://app1.authing.cn');
        }
        if (this.options.protocol === 'oidc') {
            return this._buildOidcAuthorizeUrl(options);
        }
        if (this.options.protocol === 'oauth') {
            return this._buildOauthAuthorizeUrl(options);
        }
        if (this.options.protocol === 'saml') {
            return this._buildSamlAuthorizeUrl();
        }
        if (this.options.protocol === 'cas') {
            return this._buildCasAuthorizeUrl(options);
        }
        throw new Error('不支持的协议类型，请在初始化 AuthenticationClient 时传入 protocol 参数，可选值为 oidc、oauth、saml、cas');
    };
    AuthenticationClient.prototype._buildOidcAuthorizeUrl = function (options) {
        var map = {
            appId: 'client_id',
            scope: 'scope',
            state: 'state',
            nonce: 'nonce',
            responseMode: 'response_mode',
            responseType: 'response_type',
            redirectUri: 'redirect_uri',
            codeChallenge: 'code_challenge',
            codeChallengeMethod: 'code_challenge_method',
            tenantId: 'tenant_id'
        };
        var res = {
            nonce: Math.random()
                .toString()
                .slice(2),
            state: Math.random()
                .toString()
                .slice(2),
            scope: 'openid profile email phone address',
            client_id: this.options.appId,
            redirect_uri: this.options.redirectUri,
            response_type: 'code'
        };
        Object.keys(map).forEach(function (k) {
            if (options && options[k]) {
                if (k === 'scope' && options.scope.includes('offline_access')) {
                    res.prompt = 'consent';
                }
                res[map[k]] = options[k];
            }
        });
        var params = new URLSearchParams(res);
        var authorizeUrl = this.baseClient.appHost + '/oidc/auth?' + params.toString();
        return authorizeUrl;
    };
    AuthenticationClient.prototype._buildOauthAuthorizeUrl = function (options) {
        var map = {
            appId: 'client_id',
            scope: 'scope',
            state: 'state',
            responseType: 'response_type',
            redirectUri: 'redirect_uri'
        };
        var res = {
            state: Math.random()
                .toString()
                .slice(2),
            scope: 'user',
            client_id: this.options.appId,
            redirect_uri: this.options.redirectUri,
            response_type: 'code'
        };
        Object.keys(map).forEach(function (k) {
            if (options && options[k]) {
                res[map[k]] = options[k];
            }
        });
        var params = new URLSearchParams(res);
        var authorizeUrl = this.baseClient.appHost + '/oauth/auth?' + params.toString();
        return authorizeUrl;
    };
    AuthenticationClient.prototype._buildSamlAuthorizeUrl = function () {
        return this.baseClient.appHost + '/api/v2/saml-idp/' + this.options.appId;
    };
    AuthenticationClient.prototype._buildCasAuthorizeUrl = function (options) {
        if (options === null || options === void 0 ? void 0 : options.service) {
            return "".concat(this.baseClient.appHost, "/cas-idp/").concat(this.options.appId, "?service=").concat(options === null || options === void 0 ? void 0 : options.service);
        }
        return "".concat(this.baseClient.appHost, "/cas-idp/").concat(this.options.appId);
    };
    AuthenticationClient.prototype._buildCasLogoutUrl = function (options) {
        if (options === null || options === void 0 ? void 0 : options.redirectUri) {
            return (this.baseClient.appHost + '/cas-idp/logout?url=' + options.redirectUri);
        }
        return "".concat(this.baseClient.appHost, "/cas-idp/logout");
    };
    AuthenticationClient.prototype._buildOidcLogoutUrl = function (options) {
        if (options && !(options.idToken && options.redirectUri)) {
            throw new Error('必须同时传入 idToken 和 redirectUri 参数，或者同时都不传入');
        }
        if (options === null || options === void 0 ? void 0 : options.redirectUri) {
            return "".concat(this.baseClient.appHost, "/oidc/session/end?id_token_hint=").concat(options.idToken, "&post_logout_redirect_uri=").concat(options.redirectUri);
        }
        return "".concat(this.baseClient.appHost, "/oidc/session/end");
    };
    AuthenticationClient.prototype._buildEasyLogoutUrl = function (options) {
        if (options === null || options === void 0 ? void 0 : options.redirectUri) {
            return "".concat(this.baseClient.appHost, "/login/profile/logout?redirect_uri=").concat(options.redirectUri);
        }
        return "".concat(this.baseClient.appHost, "/login/profile/logout");
    };
    AuthenticationClient.prototype.buildLogoutUrl = function (options) {
        if (this.options.protocol === 'cas') {
            return this._buildCasLogoutUrl(options);
        }
        if (this.options.protocol === 'oidc' && (options === null || options === void 0 ? void 0 : options.expert)) {
            return this._buildOidcLogoutUrl(options);
        }
        return this._buildEasyLogoutUrl(options);
    };
    AuthenticationClient.prototype._getNewAccessTokenByRefreshTokenWithClientSecretPost = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var qstr, api, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            client_secret: this.options.secret,
                            grant_type: 'refresh_token',
                            refresh_token: refreshToken
                        });
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype._getNewAccessTokenByRefreshTokenWithClientSecretBasic = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        qstr = this._generateTokenRequest({
                            grant_type: 'refresh_token',
                            refresh_token: refreshToken
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                data: qstr,
                                method: 'POST',
                                url: api,
                                headers: {
                                    Authorization: this._generateBasicAuthToken()
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype._getNewAccessTokenByRefreshTokenWithNone = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token");
                        }
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            grant_type: 'refresh_token',
                            refresh_token: refreshToken
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype.getNewAccessTokenByRefreshToken = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!['oauth', 'oidc'].includes(this.options.protocol)) {
                            throw new Error('初始化 AuthenticationClient 时传入的 protocol 参数必须为 oauth 或 oidc，请检查参数');
                        }
                        if (!this.options.secret &&
                            this.options.tokenEndPointAuthMethod !== 'none') {
                            throw new Error('请在初始化 AuthenticationClient 时传入 appId 和 secret 参数');
                        }
                        if (!(this.options.tokenEndPointAuthMethod === 'client_secret_post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._getNewAccessTokenByRefreshTokenWithClientSecretPost(refreshToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(this.options.tokenEndPointAuthMethod === 'client_secret_basic')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._getNewAccessTokenByRefreshTokenWithClientSecretBasic(refreshToken)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(this.options.tokenEndPointAuthMethod === 'none')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._getNewAccessTokenByRefreshTokenWithNone(refreshToken)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationClient.prototype._revokeTokenWithClientSecretPost = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var qstr, api, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            client_secret: this.options.secret,
                            token: token
                        });
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/revocation");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token/revocation");
                        }
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype._revokeTokenWithClientSecretBasic = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/revocation");
                        }
                        else if (this.options.protocol === 'oauth') {
                            throw new Error('OAuth 2.0 暂不支持用 client_secret_basic 模式身份验证撤回 Token');
                            api = "".concat(this.baseClient.appHost, "/oauth/token/revocation");
                        }
                        qstr = this._generateTokenRequest({
                            token: token
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                data: qstr,
                                method: 'POST',
                                url: api,
                                headers: {
                                    Authorization: this._generateBasicAuthToken()
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AuthenticationClient.prototype._revokeTokenWithNone = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/revocation");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token/revocation");
                        }
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            token: token
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AuthenticationClient.prototype.revokeToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!['oauth', 'oidc'].includes(this.options.protocol)) {
                            throw new Error('初始化 AuthenticationClient 时传入的 protocol 参数必须为 oauth 或 oidc，请检查参数');
                        }
                        if (!this.options.secret &&
                            this.options.revocationEndPointAuthMethod !== 'none') {
                            throw new Error('请在初始化 AuthenticationClient 时传入 appId 和 secret 参数');
                        }
                        if (!(this.options.revocationEndPointAuthMethod === 'client_secret_post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._revokeTokenWithClientSecretPost(token)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        if (!(this.options.revocationEndPointAuthMethod === 'client_secret_basic')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._revokeTokenWithClientSecretBasic(token)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        if (!(this.options.revocationEndPointAuthMethod === 'none')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._revokeTokenWithNone(token)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 6: throw new Error('初始化 AuthenticationClient 时传入的 revocationEndPointAuthMethod 参数可选值为 client_secret_base、client_secret_post、none，请检查参数');
                }
            });
        });
    };
    AuthenticationClient.prototype._introspectTokenWithClientSecretPost = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var qstr, api, tokenSet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            client_secret: this.options.secret,
                            token: token
                        });
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/introspection");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token/introspection");
                        }
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })];
                    case 1:
                        tokenSet = _a.sent();
                        return [2 /*return*/, tokenSet];
                }
            });
        });
    };
    AuthenticationClient.prototype._introspectTokenWithClientSecretBasic = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/introspection");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token/introspection");
                        }
                        qstr = this._generateTokenRequest({
                            token: token
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                data: qstr,
                                method: 'POST',
                                url: api,
                                headers: {
                                    Authorization: this._generateBasicAuthToken()
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AuthenticationClient.prototype._introspectTokenWithNone = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var api, qstr, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = '';
                        if (this.options.protocol === 'oidc') {
                            api = "".concat(this.baseClient.appHost, "/oidc/token/introspection");
                        }
                        else if (this.options.protocol === 'oauth') {
                            api = "".concat(this.baseClient.appHost, "/oauth/token/introspection");
                        }
                        qstr = this._generateTokenRequest({
                            client_id: this.options.appId,
                            token: token
                        });
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'POST',
                                url: api,
                                data: qstr
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AuthenticationClient.prototype.introspectToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!['oauth', 'oidc'].includes(this.options.protocol)) {
                            throw new Error('初始化 AuthenticationClient 时传入的 protocol 参数必须为 oauth 或 oidc，请检查参数');
                        }
                        if (!this.options.secret &&
                            this.options.introspectionEndPointAuthMethod !== 'none') {
                            throw new Error('请在初始化 AuthenticationClient 时传入 appId 和 secret 参数');
                        }
                        if (!(this.options.introspectionEndPointAuthMethod === 'client_secret_post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._introspectTokenWithClientSecretPost(token)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(this.options.introspectionEndPointAuthMethod === 'client_secret_basic')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._introspectTokenWithClientSecretBasic(token)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(this.options.introspectionEndPointAuthMethod === 'none')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._introspectTokenWithNone(token)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: throw new Error('初始化 AuthenticationClient 时传入的 introspectionEndPointAuthMethod 参数可选值为 client_secret_base、client_secret_post、none，请检查参数');
                }
            });
        });
    };
    AuthenticationClient.prototype.validateTicketV1 = function (ticket, service) {
        return __awaiter(this, void 0, void 0, function () {
            var api, result, valid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = "".concat(this.baseClient.appHost, "/cas-idp/").concat(this.options.appId, "/validate");
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'GET',
                                url: api,
                                params: {
                                    service: service,
                                    ticket: ticket
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        valid = result.split('\n')[0];
                        return [2 /*return*/, __assign({ valid: valid === 'yes' }, (valid !== 'yes' && { message: 'ticket 不合法' }))];
                }
            });
        });
    };
    AuthenticationClient.prototype.validateTicketV2 = function (ticket, service, format) {
        if (format === void 0) { format = 'JSON'; }
        return __awaiter(this, void 0, void 0, function () {
            var api, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ticket) {
                            throw new Error('请传入 ticket 一次性票据');
                        }
                        if (!service) {
                            throw new Error('请传入 service 服务地址');
                        }
                        if (format !== 'XML' && format !== 'JSON') {
                            throw new Error('format 参数可选值为 XML、JSON，请检查输入');
                        }
                        api = "".concat(this.baseClient.appHost, "/cas-idp/").concat(this.options.appId, "/serviceValidate");
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                method: 'GET',
                                url: api,
                                params: {
                                    service: service,
                                    ticket: ticket,
                                    format: format
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 判断 "我" 是否有某个角色
     * @param roleCode 角色 Code
     * @param namespace 权限分组 ID
     */
    AuthenticationClient.prototype.hasRole = function (roleCode, namespace) {
        return __awaiter(this, void 0, void 0, function () {
            var user, roleList, hasRole;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getUserRoles(this.graphqlClient, this.tokenProvider, {
                            id: this.checkLoggedIn(),
                            namespace: namespace
                        })];
                    case 1:
                        user = (_a.sent()).user;
                        if (!user) {
                            return [2 /*return*/, false];
                        }
                        roleList = user.roles;
                        if (roleList.totalCount < 1) {
                            return [2 /*return*/, false];
                        }
                        hasRole = false;
                        roleList.list.forEach(function (item) {
                            if (item.code === roleCode) {
                                hasRole = true;
                            }
                        });
                        return [2 /*return*/, hasRole];
                }
            });
        });
    };
    /**
     * @description 获取当前用户能够访问的应用
     */
    AuthenticationClient.prototype.listApplications = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, page, _c, limit, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = params || {}, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 10 : _c;
                        return [4 /*yield*/, this.httpClient.request({
                                url: "".concat(this.baseClient.appHost, "/api/v2/users/me/applications/allowed?page=").concat(page, "&limit=").concat(limit),
                                method: 'GET'
                            })];
                    case 1:
                        data = _d.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @description 检验 idToken 或 accessToken
     */
    AuthenticationClient.prototype.validateToken = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var data, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!options) {
                            throw new Error('请在传入的参数对象中包含 accessToken 或 idToken 字段');
                        }
                        if (options.accessToken && options.idToken) {
                            throw new Error('accessToken 和 idToken 只能传入一个，不能同时传入');
                        }
                        if (!options.idToken) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                url: "".concat(this.baseClient.appHost, "/api/v2/oidc/validate_token"),
                                method: 'GET',
                                params: {
                                    id_token: options.idToken
                                }
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 2:
                        if (!options.accessToken) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.naiveHttpClient.request({
                                url: "".concat(this.baseClient.appHost, "/api/v2/oidc/validate_token"),
                                method: 'GET',
                                params: {
                                    access_token: options.accessToken
                                }
                            })];
                    case 3:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @description sso 检测登录态
     */
    AuthenticationClient.prototype.trackSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.naiveHttpClient.request({
                            url: "".concat(this.baseClient.appHost, "/cas/session"),
                            method: 'GET'
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /*
     * 在本地检验 ID Token 或 Access Token 的有效性，并返回其包含的内容。
     * 如果签名模式是 HS256，必须在初始化参数中传入 appSecret。
     * 如果开启了 Token 加密功能，请使用 decryptTokenLocally。
     * @param token 待检验的 Token
     * @returns Token 的内容
     */
    // async validateTokenLocally(token: string) {
    //   const { payload } = await compactVerify(token, (header: any) =>
    //     this.keyManager.getKeyFor({
    //       alg: header.alg,
    //       kid: header.kid
    //     })
    //   );
    //   return JSON.parse(new TextDecoder().decode(payload));
    // }
    /**
     * 在本地利用私钥解密 ID Token 或 Access Token ，检验其有效性并返回包含的内容。
     * 只在开启 Token 加密功能的情况下使用，反之请使用 validateTokenLocally。
     * 必须在初始化参数中传入 privateKeys。
     * @param token 待检验的 Token
     * @returns Token 的内容
     */
    // async decryptTokenLocally(token: string) {
    //   const { plaintext } = await compactDecrypt(token, (header: any) =>
    //     this.keyManager.getKeyFor({
    //       alg: header.alg,
    //       kid: header.kid
    //     })
    //   );
    //   return this.validateTokenLocally(new TextDecoder().decode(plaintext));
    // }
    /**
     * @description 设置语言
     */
    AuthenticationClient.prototype.setLang = function (lang) {
        this.options.lang = lang;
    };
    return AuthenticationClient;
}());
export { AuthenticationClient };
//# sourceMappingURL=AuthenticationClient.js.map